import React from "react";
import Button from "./Button";

function CSVDownloadButton({
  onDownload,
  disabled = false,
  className = "",
  children = "Download CSV",
}) {
  return (
    <Button
      onClick={onDownload}
      disabled={disabled}
      variant="success"
      className={className}
    >
      {children}
    </Button>
  );
}

export default CSVDownloadButton;
